import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/menu.scss';
import Color from '@tool/color';
import { DownFullIcon, DownloadIcon } from '@styled/icon';
import moMenu, {
  toggleTip,
} from './store/menu';
import moUser from '@store/user';
import moSingle, {
  toggleSingle,
} from '@/page/effect/component/single-industry/store/index';
import moMulti, {
  toggleMulti,
} from '@/page/effect/component/multi-industry/store/index';
import moSample, {
  toggleSample,
} from '@/page/effect/component/company-sample/store/index';
import moEffect, { changePdfModel, toggleLook } from './store/index';
import posthog from 'posthog-js';

interface IProps { }
interface IState { }

const DButton = styled(Button)(() => ({
  minWidth: '165px',
  maxWidth: '200px',
  height: '40px',
  padding: '0 10px 0 16px',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '4px',
  border: '1px solid rgba(0, 0, 0, 0.1)',

  '& .text': {
    flex: 1,
    display: 'inline-flex',
    color: Color.blackColor(1),
  },
}));

const EButton = styled(Button)(() => ({
  padding: 0,
  marginBottom: '10px',
  fontWeight: 400,
}));

const Menu = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isEfficiencyExpired } = moUser;
  const { industry } = moSingle;
  const { compareIndustry } = moMulti;
  const {
    industryName, compareList, companyFilter,
    filterLength, chooseCompany,
  } = moMenu;

  useEffect(() => {
    return () => { };
  }, []);

  const onSingle = () => {
    if (isEfficiencyExpired) toggleTip(true);
    else toggleSingle(true);
  };

  const onMulti = () => {
    if (isEfficiencyExpired) toggleTip(true);
    else toggleMulti(true);
  };

  const onSample = () => {
    if (isEfficiencyExpired) toggleTip(true);
    else toggleSample(true);
  };

  const onLook = () => {
    if (isEfficiencyExpired) toggleTip(true);
    else toggleLook(true);
  };

  const exportPdf = () => {
    posthog.capture('人力核心指标导出pdf', {});
    changePdfModel(true);
  };

  return (
    <section className="menu-60">
      <section className="section-0101">
        <b>我所属行业</b>
        <DButton endIcon={<DownFullIcon color={Color.d9} />}
          onClick={onSingle}>
          <span className="text">{industryName}</span>
        </DButton>
      </section>
      <section className="section-0101">
        <p className="line-001">
          <b>样本筛选</b>
          <EButton onClick={onLook}>查看样本</EButton>
        </p>
        <DButton endIcon={<DownFullIcon color={Color.d9} />}
          onClick={onSample}>
          <span className="text">已选{chooseCompany.length}家公司</span>
        </DButton>
      </section>
      <section className="section-0101">
        <b>对比的行业</b>
        <DButton endIcon={<DownFullIcon color={Color.d9} />}
          onClick={onMulti}>
          <span className="text">已选{compareList.length}个行业</span>
        </DButton>
      </section>
      <section className="section-0101">
        <b>分享</b>
        <section className="effect-pdf-export" onClick={exportPdf}>
          <DownloadIcon color={Color.primary} /> &nbsp;导出报告
        </section>
      </section>
    </section>
  );
};

export default observer(Menu);
